import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRocket = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 13L6.35061 15.0617C6.22066 15.2242 6.15569 15.3054 6.10948 15.3958C6.06849 15.4761 6.03853 15.5615 6.02042 15.6497C6 15.7492 6 15.8532 6 16.0612V21L10 16M16 13L17.6494 15.0617C17.7793 15.2242 17.8443 15.3054 17.8905 15.3958C17.9315 15.4761 17.9615 15.5615 17.9796 15.6497C18 15.7492 18 15.8532 18 16.0612V21L14 16M12 13V20M8 8H16M12 3L8.40415 7.04534C8.25464 7.21353 8.17989 7.29762 8.1266 7.3932C8.07933 7.47797 8.04466 7.56917 8.02367 7.66393C8 7.77077 8 7.88329 8 8.10832V12C8 13.4001 8 14.1002 8.27248 14.635C8.51217 15.1054 8.89462 15.4878 9.36502 15.7275C9.8998 16 10.5999 16 12 16C13.4001 16 14.1002 16 14.635 15.7275C15.1054 15.4878 15.4878 15.1054 15.7275 14.635C16 14.1002 16 13.4001 16 12V8.10832C16 7.88329 16 7.77077 15.9763 7.66393C15.9553 7.56917 15.9207 7.47797 15.8734 7.3932C15.8201 7.29762 15.7454 7.21353 15.5959 7.04534L12 3Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRocket;
